/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpConfigInterceptorService } from './http-config-interceptor.service';
import { RequestHeaderInterceptorService } from './CommonRequestHeaderInterceptorService';
import { SecurityInterceptorService } from './security-interceptor.service'

export const InterceptorProviders =
  [
    { provide: HTTP_INTERCEPTORS, useClass: RequestHeaderInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SecurityInterceptorService, multi: true }
  ];
